module.exports = __webpack_public_path__ + "band_7.f84902e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_7.png
// module id = nvK/
// module chunks = 0